(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ==============================================
     STICKY HEADER (transparent → opaque on scroll)
     ============================================== */
  class StickyHeader extends HTMLElement {
    constructor() { super(); }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size' ||
        /* IRIS sub-line pages: keep the frosted header visible whenever
           scrolled (it never hides on scroll-down), blending to transparent
           only at the very top. */
        document.body.classList.contains('iris-collection') ||
        document.body.classList.contains('iris-product');
      this.headerBounds = {};

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      /* Read the real scroll position NOW and apply the correct state
         synchronously before the first paint the element can influence.
         The server-side HTML already ships with data-rsai-at-top + inline
         transparent, but if the browser restored a scrolled position we
         must flip to scrolled immediately rather than painting transparent
         and then flashing to white. */
      this.onScroll();

      this.createObserver();

      /* Also re-assert on load (stylesheets finished) and on pageshow
         (bfcache restore). pageshow is the key one: on back/forward nav
         the DOM is reused but scroll position is restored AFTER our
         connectedCallback ran on the original load. */
      window.addEventListener('load', this.onScrollHandler, { once: true });
      window.addEventListener('pageshow', this.onScrollHandler);
    }

    applyTopState() {
      this.classList.remove('rsai-scrolled');
      this.setAttribute('data-rsai-at-top', '');
      this.style.setProperty('background', 'transparent', 'important');
      this.style.setProperty('background-color', 'transparent', 'important');
      this.style.setProperty('background-image', 'none', 'important');
      this.style.setProperty('box-shadow', 'none', 'important');
    }

    applyScrolledState() {
      this.classList.add('rsai-scrolled');
      this.removeAttribute('data-rsai-at-top');
      /* Paint the translucent background via inline style — this wins every
         specificity battle regardless of which Dawn class or color-scheme is
         applied. No CSS class is responsible for the background anymore,
         eliminating the first-paint cascade bug.
         On IRIS sub-line pages (body.iris-collection) paint Daylight cream
         instead of white, so the header blends into the cream banner rather
         than sitting as a stark white bar above it. */
      var scrolledBg = (document.body.classList.contains('iris-collection') ||
        document.body.classList.contains('iris-product'))
        ? 'rgba(251, 248, 242, 0.68)'
        : 'rgba(255, 255, 255, 0.68)';
      this.style.setProperty('background', scrolledBg, 'important');
      this.style.setProperty('background-color', scrolledBg, 'important');
      this.style.setProperty('background-image', 'none', 'important');
      this.style.removeProperty('box-shadow');
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      /* Toggle the translucent white background. At top → strip the class
         AND reapply the inline transparent style so nothing else can paint
         white. Once scrolled → remove the inline style so .rsai-scrolled's
         background rule can paint the translucent white. */
      if (scrollTop > 10) {
        this.applyScrolledState();
      } else {
        this.applyTopState();
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && this.searchModal.close) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ==============================================
     COLLECTIONS MEGA DROPDOWN (hover + click)
     ============================================== */
  (function() {
    const trigger = document.querySelector('.rsai-collections-trigger');
    const dropdown = document.getElementById('rsai-mega-dropdown');
    if (!trigger || !dropdown) return;

    let hoverTimeout = null;
    let isOpen = false;

    function open() {
      clearTimeout(hoverTimeout);
      if (isOpen) return;
      isOpen = true;
      dropdown.classList.add('rsai-mega-dropdown--open');
      dropdown.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      trigger.classList.add('rsai-nav-link--active');
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      dropdown.classList.remove('rsai-mega-dropdown--open');
      dropdown.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.classList.remove('rsai-nav-link--active');
    }

    function scheduleClose() {
      clearTimeout(hoverTimeout);
      hoverTimeout = setTimeout(close, 250);
    }

    // Click toggle
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (isOpen) close(); else open();
    });

    // Hover open/close
    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('mouseleave', scheduleClose);
    dropdown.addEventListener('mouseenter', function() { clearTimeout(hoverTimeout); });
    dropdown.addEventListener('mouseleave', scheduleClose);

    // Close on Escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) { close(); trigger.focus(); }
    });

    // Close on outside click
    document.addEventListener('click', function(e) {
      if (isOpen && !trigger.contains(e.target) && !dropdown.contains(e.target)) close();
    });

    // Close when other nav links clicked
    document.querySelectorAll('.rsai-nav-link:not(.rsai-collections-trigger)').forEach(function(link) {
      link.addEventListener('click', function() { if (isOpen) close(); });
    });
  })();

  /* ==============================================
     MOBILE DRAWER (open/close/escape/overlay)
     ============================================== */
  (function() {
    const drawer   = document.getElementById('rsai-drawer');
    const overlay  = document.getElementById('rsai-drawer-overlay');
    const openBtn  = document.querySelector('[data-rsai-drawer-open]');
    const closeBtn = document.querySelector('[data-rsai-drawer-close]');
    if (!drawer || !overlay) return;

    function openDrawer() {
      drawer.classList.add('rsai-drawer--open');
      overlay.classList.add('rsai-drawer-overlay--open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('rsai-drawer-is-open');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      // Focus the close button for accessibility
      if (closeBtn) setTimeout(function() { closeBtn.focus(); }, 100);
    }

    function closeDrawer() {
      drawer.classList.remove('rsai-drawer--open');
      overlay.classList.remove('rsai-drawer-overlay--open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('rsai-drawer-is-open');
      if (openBtn) {
        openBtn.setAttribute('aria-expanded', 'false');
        openBtn.focus();
      }
    }

    if (openBtn)  openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('rsai-drawer--open')) closeDrawer();
    });
  })();

  /* ==============================================
     MOBILE CART BADGE SYNC
     Dawn's cart JS (cart-notification.js, cart.js, cart-drawer.js) all update
     #cart-icon-bubble (the hidden desktop icon) but never touch the mobile icon.
     This MutationObserver watches the desktop icon and mirrors badge state
     to the mobile cart icon immediately whenever Dawn updates it.
     ============================================== */
  (function() {
    function syncMobileCartBadge() {
      var desktopIcon = document.getElementById('cart-icon-bubble');
      var mobileIcon = document.querySelector('.rsai-mobile-right .rsai-header-icon');
      if (!desktopIcon || !mobileIcon) return;

      var desktopBadge = desktopIcon.querySelector('.rsai-cart-badge');
      var mobileBadge  = mobileIcon.querySelector('.rsai-cart-badge');

      if (desktopBadge) {
        var count = desktopBadge.textContent.trim();
        if (mobileBadge) {
          // Update count in-place (avoids removing/re-adding the element)
          if (mobileBadge.textContent.trim() !== count) mobileBadge.textContent = count;
        } else {
          var newBadge = document.createElement('span');
          newBadge.className = 'rsai-cart-badge';
          newBadge.setAttribute('aria-hidden', 'true');
          newBadge.textContent = count;
          mobileIcon.appendChild(newBadge);
        }
      } else {
        if (mobileBadge) mobileBadge.remove();
      }
    }

    function initMobileCartSync() {
      var desktopIcon = document.getElementById('cart-icon-bubble');
      if (!desktopIcon) return;
      var observer = new MutationObserver(syncMobileCartBadge);
      // childList catches the wholesale innerHTML replacement Dawn does;
      // subtree + characterData catches any nested text updates.
      observer.observe(desktopIcon, { childList: true, subtree: true, characterData: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMobileCartSync);
    } else {
      initMobileCartSync();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
